/**
 * Layout Constants - Constantes padronizadas para o layout da MainPage
 *
 * 2ECOMP: PremiumUI Refresh — constantes centralizadas
 *
 * Hierarquia de referência (PremiumUI Refresh):
 * ┌─────────────────────────────────────────────────────────────────────┐
 * │                           TOPBAR (48px)                             │
 * ├───────┬──────┬─────────────────────────────────────────────────┬───┤
 * │       │      │ [StatusCard]            [Geofence] [POI]        │CTL│
 * │ MENU  │DEVICE│ (left=454, top=52)      (top=56)                │(40│
 * │  NAV  │ LIST │                                                 │   │
 * │       │(280) │                                                 │[+]│
 * │ icons │      │              MAP AREA                           │[-]│
 * │   +   │      │                                                 │...│
 * │ text  │      │                                                 │   │
 * │ 170px │      ├────────────────────────────────────────────────┤   │
 * │       │      │          DEVICE DETAIL PANEL (160px)            │   │
 * │       │      │          left=454, right=4, bottom=4            │   │
 * └───────┴──────┴────────────────────────────────────────────────┴───┘
 *   gap(4px)             gap(4px)                            gap(4px)
 */

// ─── TopBar ───────────────────────────────────────────────────
// 2ECOMP: PremiumUI Refresh — CORREÇÃO GAP-1: era 64px, valor real é 48px
// MainPage já importava 48px de TopBar.jsx; agora layout.js está alinhado
export const TOPBAR_HEIGHT = 48;
export const TOPBAR_BUTTON_HEIGHT = 40; // Altura dos botões na TopBar

// ─── Icon Bar (novo — PremiumUI Refresh) ──────────────────────
export const ICON_BAR_WIDTH = 170; // 2ECOMP: PremiumUI Refresh — menu expandido com texto (igual GPSWOX)
export const ICON_BAR_COLLAPSED_WIDTH = 50; // 2ECOMP: PremiumUI Refresh — menu colapsado (só ícones)

// ─── Device List Panel (novo — PremiumUI Refresh) ─────────────
export const DEVICE_LIST_WIDTH = 360; // 2ECOMP: PremiumUI Refresh — lista mais larga

// ─── Sidebar combinada (novo — PremiumUI Refresh) ─────────────
export const SIDEBAR_OPEN_WIDTH = ICON_BAR_WIDTH + DEVICE_LIST_WIDTH; // 530px (170+360)
export const SIDEBAR_CLOSED_WIDTH = ICON_BAR_WIDTH; // 50px

// ─── Sidebar legada (retrocompatibilidade) ────────────────────
// 2ECOMP: PremiumUI Refresh — DEPRECATED, usar SIDEBAR_OPEN_WIDTH
/** @deprecated Use SIDEBAR_OPEN_WIDTH (330px) instead. Mantido para path mobile. */
export const SIDEBAR_WIDTH = 400;

// ─── Controles do mapa ────────────────────────────────────────
export const CONTROLS_WIDTH = 40; // Largura real dos controles do mapa (zoom, layers)

// ─── Bottom Panel ─────────────────────────────────────────────
// 2ECOMP: PremiumUI Refresh — altura redesenhada (era 120px)
export const BOTTOM_PANEL_HEIGHT = 160;
/** @deprecated Use BOTTOM_PANEL_HEIGHT (160px) instead. Migrado em E3-S1. */
export const DEVICE_DETAIL_HEIGHT = 120;
export const DEVICE_DETAIL_COLLAPSED_BUTTON_HEIGHT = 32;

// ─── Device Row (novo — PremiumUI Refresh) ────────────────────
export const DEVICE_ROW_HEIGHT = 56; // 2ECOMP: PremiumUI Refresh — 2 linhas (nome + timestamp)
export const DEVICE_GROUP_HEIGHT = 40; // 2ECOMP: PremiumUI Refresh — header de grupo

// ─── Gaps padronizados (baseados em theme.spacing) ────────────
export const GAP = {
  TINY: 2, // theme.spacing(0.25)
  SMALL: 4, // theme.spacing(0.5) - gap padrão entre elementos
  MEDIUM: 8, // theme.spacing(1) - gap entre seções
  LARGE: 16, // theme.spacing(2) - gap grande
  XLARGE: 24, // theme.spacing(3) - gap extra grande
};

// ─── Dimensões dos widgets ────────────────────────────────────
export const WIDGET_DIMENSIONS = {
  statusCounters: { width: 100, height: 340 },
  poiFilter: { width: 220, height: 'auto' },
  geofenceFilter: { width: 220, height: 'auto' },
  speedometer: { width: 180, height: 220 },
  speedometerMinimized: { width: 100, height: 50 },
};

// ─── Posições calculadas para widgets ─────────────────────────
export const WIDGET_POSITIONS = {
  // StatusCountersPanel - canto superior esquerdo do mapa
  statusCounters: {
    top: TOPBAR_HEIGHT - 42, // 6px - calibrado visualmente
    left: SIDEBAR_WIDTH + GAP.SMALL, // 404px (legado, será migrado)
  },

  // StatusCard - topo do mapa, ao lado da sidebar
  statusCard: {
    left: SIDEBAR_WIDTH + GAP.SMALL, // 404px (legado, será migrado)
    top: TOPBAR_HEIGHT - GAP.SMALL - 5, // 39px
  },

  // POI Filter Panel - canto superior direito
  poiFilter: {
    top: TOPBAR_HEIGHT + GAP.MEDIUM, // 56px
    right: CONTROLS_WIDTH + GAP.XLARGE + GAP.MEDIUM, // 72px
  },

  // Geofence Filter Panel - ao lado esquerdo do POI filter
  geofenceFilter: {
    top: TOPBAR_HEIGHT + GAP.MEDIUM, // 56px
    right: CONTROLS_WIDTH + GAP.XLARGE + GAP.MEDIUM + WIDGET_DIMENSIONS.poiFilter.width + GAP.MEDIUM, // 300px
  },

  // Speedometer - canto inferior direito
  speedometer: {
    right: GAP.SMALL,
    bottom: 122, // Calibrado visualmente
  },
};

// ─── Posições dos controles do mapa ───────────────────────────
export const MAP_CONTROLS = {
  top: TOPBAR_BUTTON_HEIGHT + 6, // 46px - abaixo dos botões da TopBar
  right: GAP.SMALL,
  bottom: GAP.SMALL,
};

// ─── Dimensões dos painéis de filtro ──────────────────────────
export const FILTER_PANEL = {
  WIDTH: 220,
  MIN_HEIGHT: 200,
  MAX_HEIGHT: 400,
};

// ─── Z-Index hierarchy ────────────────────────────────────────
// 2ECOMP: PremiumUI Refresh — adicionados ICON_BAR, DRAGGABLE_FILTER,
// FOLLOW_POPUP_BASE, SPEEDOMETER
export const Z_INDEX = {
  MAP: 1,
  SIDEBAR: 3, // Legado — será substituído por ICON_BAR
  ICON_BAR: 3, // 2ECOMP: PremiumUI Refresh
  DEVICE_LIST: 4,
  MAP_CONTROLS: 5,
  DRAGGABLE_FILTER: 1000, // 2ECOMP: PremiumUI Refresh
  WIDGETS: 1100,
  DEVICE_DETAIL: 1200,
  FOLLOW_POPUP_BASE: 1200, // 2ECOMP: PremiumUI Refresh — + index do popup
  STATUS_CARD: 1201,
  MODALS: 1300,
  TOPBAR: 1400,
  SPEEDOMETER: 9999, // 2ECOMP: PremiumUI Refresh — acima de tudo
};

// ─── Transições (novo — PremiumUI Refresh) ────────────────────
export const SIDEBAR_TRANSITION = 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)'; // 2ECOMP: PremiumUI Refresh
export const SELECTION_TRANSITION = 'all 150ms ease'; // 2ECOMP: PremiumUI Refresh

// ─── Helper functions ─────────────────────────────────────────

/** CSS value com px */
export const px = (value) => `${value}px`;

/** Posição à direita da sidebar legada (400px + gap) */
export const fromSidebar = (gap = GAP.SMALL) => SIDEBAR_WIDTH + GAP.SMALL + gap;

/** Posição abaixo da TopBar */
export const fromTopBar = (gap = GAP.SMALL) => TOPBAR_HEIGHT + gap;

/** Posição acima do DeviceDetailPanel */
export const fromDeviceDetail = (gap = GAP.SMALL) => DEVICE_DETAIL_HEIGHT + gap;

/** Posição à esquerda dos controles do mapa */
export const fromControls = (gap = GAP.SMALL) => CONTROLS_WIDTH + gap;

// 2ECOMP: PremiumUI Refresh — novos helpers
/** Posição à direita do icon bar (50px + gap) */
export const fromIconBar = (gap = GAP.SMALL) => ICON_BAR_WIDTH + gap;

/** Posição à direita do device list aberto (330px + gap) */
export const fromDeviceList = (gap = GAP.SMALL) => SIDEBAR_OPEN_WIDTH + gap;

export default {
  TOPBAR_HEIGHT,
  TOPBAR_BUTTON_HEIGHT,
  ICON_BAR_WIDTH,
  ICON_BAR_COLLAPSED_WIDTH,
  DEVICE_LIST_WIDTH,
  SIDEBAR_OPEN_WIDTH,
  SIDEBAR_CLOSED_WIDTH,
  SIDEBAR_WIDTH,
  CONTROLS_WIDTH,
  BOTTOM_PANEL_HEIGHT,
  DEVICE_DETAIL_HEIGHT,
  DEVICE_DETAIL_COLLAPSED_BUTTON_HEIGHT,
  DEVICE_ROW_HEIGHT,
  DEVICE_GROUP_HEIGHT,
  GAP,
  WIDGET_DIMENSIONS,
  WIDGET_POSITIONS,
  MAP_CONTROLS,
  FILTER_PANEL,
  Z_INDEX,
  SIDEBAR_TRANSITION,
  SELECTION_TRANSITION,
  px,
  fromSidebar,
  fromTopBar,
  fromDeviceDetail,
  fromControls,
  fromIconBar,
  fromDeviceList,
};
